// i18n area 'vms' — locale hy-AM (task #171, onda 5): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/vms.hy-AM.meta.json.
import type { enUS } from './vms'

export const hyAM: typeof enUS = {
  vms: {
    spof: {
      title: 'Անկախություն հանգույցից',
      single: 'Խափանման միակ կետ',
      alternativesNow: 'Այլընտրանքներ հիմա',
      structural: 'Ըստ կառուցվածքի',
      binding: 'Կաշկանդող սահմանափակում',
      movableNow: 'Տեղափոխումը հնարավոր է հիմա',
    },
    title: 'Վիրտուալ մեքենաներ',
    migratingChip: 'Միգրացիան ընթացքի մեջ է',
    templateChip: 'Ձևանմուշ',
    expendableTooltip: 'Դեգրադացված կլաստերում այն առաջիններից է, որ ընկնում է, և հանգույցի կորստից հետո կարող է չվերագործարկվել։',
    expendableHaTooltip: 'Միշտ վերագործարկվում է, քանի դեռ կլաստերն առողջ է. դեգրադացված կլաստերում պաշտպանված VM-ները առաջնահերթ են — այն կարող է կանգնեցվել կամ մնալ անջատված, մինչև կլաստերը նորից ամբողջանա, ապա ինքն է վերագործարկվում։',
    viewDetails: 'Տեսնել մանրամասները',
    profileLegacy: 'Այլ ՕՀ',
    hugePagesNone: 'Ոչ մի — սովորական հիշողություն',
    hugePages2M: '2 MiB էջեր',
    hugePages1G: '1 GiB էջեր',
    searchPlaceholder: 'Որոնեք ըստ անվան',
    name: 'Անուն',

    // ՄԵԿ տերմինաբանություն (#94a). phase-ը ամենուր կոչվում է «Փուլ» — հին
    // 'state' բանալին մեռավ ցուցակի հղկման հետ:
    vcpus: 'vCPU',
    memory: 'Հիշողություն',
    ipAddresses: 'IP հասցեներ',
    noIp: 'IP չկա',
    authorityNode: 'Պատասխանատու հանգույց',
    authorityNextStart: 'նշանակվում է հաջորդ գործարկման ժամանակ',
    scope: 'Սկոուպ',
    empty: 'Վիրտուալ մեքենաներ չկան',
    loadError: 'Չհաջողվեց բեռնել վիրտուալ մեքենաները — TVirt բեքենդը հասանելի՞ է',
    filterOverlay: 'օվերլեյ ցանց',
    filterDisk: 'սկավառակ',
    filterImage: 'պատկեր',
    filteredBy: 'Զտված ըստ {kind}-ի',
    filterPhase: 'Փուլ',
    filterProtection: 'Պաշտպանություն',
    filterAll: 'Բոլորը',
    filterScopePlaceholder: 'Զտել ըստ սկոուպի',
    filtersToggle: 'Զտիչներ',
    scopeTree: {
      title: 'Սկոուպներ',
      all: 'Ամբողջ կլաստերը',
      noChildren: 'Այստեղ ենթասկոուպներ չկան',
      recursive: 'Ներառել ժառանգներին',
      collapse: 'Ծալել սկոուպների պանելը',
      up: 'Մեկ մակարդակ վերև',
      countTooltip: '{direct} VM՝ այս սկոուպում · {total}՝ ժառանգների հետ'
    },

    // Երկքայլ ISO ընտրիչը (#85). նախ կատալոգը, ապա նրա ISO-ները:
    isoPicker: {
      catalog: 'Կատալոգ',
      unknownCatalog: 'Տեսանելի կատալոգներից դուրս',
      noIsos: 'Այս կատալոգում պատրաստ ISO պատկեր չկա'
    },
    actionsHeader: 'Գործողություններ',
    templatesTab: {
      quickDeploy: 'QuickDeploy',
      hardware: 'Սարքաշար',
      tags: 'Թեգեր',
      age: 'Տարիք',
      disk: 'սկավառակ',
      disks: 'սկավառակ',
      empty: 'Ձևանմուշներ չկան — նշեք անջատված VM-ը որպես ձևանմուշ, կամ կլոնավորեք VM-ը որպես ձևանմուշ։',
      clone: 'Կլոնավորել / տեղակայել',
      editTags: 'Խմբագրել թեգերը',

      // Ռաունդ K3 (#64). արտահանել ձևանմուշը որպես կատալոգի .tvtpl ֆայլ:
      exportAction: 'Արտահանել կատալոգ (.tvtpl)',
      exportTitle: 'Արտահանել կատալոգ',
      exportSubmit: 'Արտահանել',
      exportError: 'Արտահանումը չհաջողվեց',
      exportHint: 'Ձևանմուշը փաթեթավորվում է .tvtpl արխիվում (սարքաշարի մանիֆեստ + ամեն սկավառակ հարթեցված qcow2-ում) որպես նոր VM ձևանմուշի ֆայլ ընտրված կատալոգում։ NIC-ները, CD/DVD կրիչները և cloud-init-ը չեն ճամփորդում — ձևաչափի սպեցիֆիկացիան թվարկում է ամեն միտումնավոր բացթողում։',
      exportName: 'Ֆայլի անուն',
      exportNameHint: 'Դատարկ = <template>-export-<n>',
      exportStorageDefault: 'Ձևանմուշի մետատվյալների պահոցը',

      // Ներմուծել կատալոգից (Luca 2026-08-03). Ձևանմուշներ ներդիրի toolbar-ի
      // մուտքը — K3/K4 բեքենդը ծածկում է vm-template բոլոր ձևաչափերը,
      // ընտրությունը ՖԱՅԼՆ է (ձևաչափը ճամփորդում է միայն ընթերցմամբ):
      importAction: 'Ներմուծել կատալոգից',
      importTitle: 'Ներմուծել կատալոգից',
      importHint: 'Ընտրված կատալոգի պատրաստ VM ձևանմուշի ֆայլը դառնում է գույքացուցակի ձևանմուշ. ֆայլի ձևաչափը (tvtpl, ova, ovf կամ մերկ qcow2) ինքն է որոշում, թե ինչպես է ներմուծվում — դուք ընտրում եք միայն ֆայլը։',
      importFile: 'Կատալոգի ֆայլ',
      importFileHint: 'Ներմուծվում են միայն պատրաստ ֆայլերը — կիսատ վերբեռնվածը ներմուծելի չէ',
      importNoFiles: 'Այս կատալոգում պատրաստ VM ձևանմուշի ֆայլ չկա — նախ վերբեռնեք կամ արտահանեք մեկը'
    },
    templateDetail: {
      quickDeploy: 'QuickDeploy համատեղելիություն',
      quickDeployNone: 'Հայտարարված չէ',
      quickDeployHint: 'Հայտարարեք այն միայն այն դեպքում, եթե golden պատկերը պարունակում է cloud-init (Linux) կամ cloudbase-init sysprep /generalize-ից հետո (Windows). հարթակը վստահում է հայտարարությանը և երբեք չի նայում հյուրի ներսը։',
      notFound: 'Ձևանմուշը չի գտնվել',
      frozen: 'Սարքաշարի կոնֆիգուրացիան սառեցված է. ձևանմուշը փոխելու համար վերադարձրեք այն VM-ի։ Անունը, նշումները և թեգերը մնում են խմբագրելի։',
      storage: 'Պահոց',
      size: 'Չափ',
      configTitle: 'Կոնֆիգուրացիա (սառեցված)',
      usbClasses: 'Պահանջվող USB դասեր',
      gpuClasses: 'Պահանջվող GPU դասեր'
    },
    sharedDisksTab: {
      title: 'Ընդհանուր սկավառակներ',
      sharing: 'Ընդհանուր օգտագործում',
      sharingNone: 'Մեկ միացում',
      sharingMultiwriter: 'Ընդհանուր գրում (multiwriter)',
      sharingReadonly: 'Ընդհանուր միայն ընթերցում',
      usedBy: 'Օգտագործում է',
      attachedTo: 'Միացված է',
      notAttached: 'Միացված չէ ոչ մի VM-ի',
      changeSharing: 'Փոխել ընդհանուր օգտագործման ռեժիմը',
      changeSharingTitle: 'Ընդհանուր օգտագործման ռեժիմ',
      changeSharingLocked: 'Ռեժիմը փոխվում է միայն այնքան ժամանակ, քանի դեռ ոչ մի VM չի օգտագործում սկավառակը',
      sharingChanged: 'Ընդհանուր օգտագործման ռեժիմը թարմացվեց։',
      lun: 'Ամբողջ LUN',
      lunNumber: 'LUN / namespace',
      lunWwn: 'WWN',
      lunSerial: 'Սերիական համար',
      antiAffinityWarning: 'Երկու կամ ավելի անդամներ աշխատում են նույն հանգույցի վրա առանց հակա-աֆինության կանոնի. մեկ հանգույցի խափանումը կտապալի բոլորին',
      antiAffinityCreate: 'Ստեղծել կանոնը',
      createSourceLun: 'Ընդունել target-ի ամբողջ LUN-ը',
      createLunNumber: 'LUN-ի համար (namespace id NVMe-ում)',
      createLunHint: 'Ոչինչ չի հատկացվում. չափը կարդացվում է սարքից ընդունելիս',
      noPr: 'Այս թողարկումում SCSI-3 persistent reservations չկան. դասական ընդհանուր սկավառակով Windows Failover Cluster-ը վավերացված չէ, իսկ ցանցով համակարգվող կլաստերները (GFS2/OCFS2, RHEL HA, shared-disk տվյալների բազաներ)՝ այո'
    },
    unusedDisksTab: {
      title: 'Չօգտագործված սկավառակներ',
      attach: 'Կցել VM-ի',
      attachTitle: 'Կցել VM-ի',
      vm: 'Վիրտուալ մեքենա',
      noVms: 'Հասանելի VM չկա',
      noSlots: 'Այս VM-ի վրա ազատ սլոթ չկա',

      // Ինքնուրույն սկավառակի ստեղծում (#87). վերադարձել է թոշակի անցած
      // գույքացուցակից, այժմ ԲԱՑԱՀԱՅՏ սկոուպի դաշտով (ժառանգելու VM չկա):
      create: 'Ստեղծել սկավառակ',
      createTitle: 'Ստեղծել սկավառակ',
      createSourceBlank: 'Դատարկ սկավառակ',
      createSourceImage: 'Կատալոգի պատկերից',
      createImage: 'Պատկեր',
      createImageEmpty: 'Տեսանելի կատալոգներում պատրաստ VM ձևանմուշի պատկեր չկա',
      createSizeFromImageHint: 'Նախալրացված է պատկերի վիրտուալ չափով — կարող է միայն աճել',

      // #107 (ԿՈՐԾԱՆԱՐԱՐ, վավերացված). qcow2 → vm-template կատալոգի ֆայլ
      // նույն պահոցի վրա, զրո բայթ պատճենված — սկավառակը դադարում է գոյություն ունենալ:
      convert: 'Փոխարկել VM ձևանմուշի…',
      convertOnlyQcow2: 'Փոխարկվում են միայն qcow2 սկավառակները — raw-ը գրանցելի ձևանմուշի ձևաչափ չէ',
      convertTitle: 'Փոխարկել VM ձևանմուշի',
      convertSubmit: 'Փոխարկել (ոչնչացնում է սկավառակը)',
      convertError: 'Չհաջողվեց սկսել փոխարկումը',
      convertWarning: 'ԿՈՐԾԱՆԱՐԱՐ. սկավառակը դառնում է VM ձևանմուշի ֆայլ ընտրված կատալոգում — նույն պահոց, զրո բայթ պատճենված — և ԴԱԴԱՐՈՒՄ Է ԳՈՅՈՒԹՅՈՒՆ ՈՒՆԵՆԱԼ որպես սկավառակ։ Ետդարձ չկա, բացի ձևանմուշից նոր սկավառակ ստեղծելուց։',
      convertNameHint: 'Կատալոգի ֆայլի անունը — լռելյայն սկավառակինն է',
      convertConfirm: 'Հասկացա. սկավառակը կոչնչացվի',
      convertStarted: 'Փոխարկումը սկսված է — ձևանմուշը կհայտնվի կատալոգում առաջադրանքի ավարտին։',
      storageLockHint: 'Պահոցը փոխվում է միայն Տեղափոխել գործողությամբ',
      source: 'Ծագում',
      sourceClone: 'Այլ սկավառակի կլոն',
      sourceCloneLinked: 'Այլ սկավառակի կապված կլոն',
      sourceImage: 'Ստեղծված պատկերից',
      sourceBlank: 'Ստեղծված դատարկ',
      allocated: 'Զբաղեցրած / վիրտուալ չափ',
      observedAt: 'Դիտարկվել է',
      snapshots: 'Սնապշոթներ',
      snapshotsEmpty: 'Սնապշոթներ չկան'
    },
    phase: {
      defined: 'Երբեք չմիացված',
      starting: 'Գործարկվում է',
      running: 'Աշխատում է',
      stopping: 'Կանգնեցվում է',
      stopped: 'Անջատված',
      paused: 'Դադարեցված',
      failed: 'Սխալի մեջ',
      deleting: 'Ջնջվում է'
    },
    stopCause: {
      'api': 'Կանգնեցված TVirt-ի կողմից (գործողություն կամ API)',
      'guest-shutdown': 'Անջատումը սկսել է հյուր օպերացիոն համակարգը',
      'crash': 'Հյուրի խափանում',
      'qemu-exit': 'QEMU պրոցեսն ավարտվեց անսպասելիորեն',
      'host-reboot': 'Հանգույցը վերագործարկվել է',
      'migrated': 'Միգրացված այլ հանգույցի վրա',
      'fenced': 'Վերացված HA ֆենսինգի կողմից (հանգույցը վերադարձել է)'
    },
    detail: {
      notFound: 'Վիրտուալ մեքենան չի գտնվել',
      details: 'Մանրամասներ',
      id: 'ID',
      scope: 'Սկոուպ',
      profile: 'Սարքաշարի պրոֆիլ',
      firmware: 'Որոնվածք',
      firmwareFile: 'UEFI որոնվածքի տարբերակ',
      firmwareUpdate: 'Հասանելի է թարմացում',
      firmwareUpdateHint: 'Պլատֆորմը մատակարարում է ավելի թարմ UEFI որոնվածք։ Թարմացումը երբեք ավտոմատ չէ. կիրառվում է անջատված VM-ի վրա, երբ դուք որոշեք։',
      arch: 'Ճարտարապետություն',
      node: 'Հանգույց',
      bootOrder: 'Բեռնման կարգ',
      agent: 'Agent-ի վիճակ',
      agentConnected: 'Միացված',
      agentNotConnected: 'Միացված չէ',
      protected: 'Պաշտպանված',
      linkedClones: 'Կապված կլոններ',
      restartPolicy: 'Վերագործարկման քաղաքականություն',
      preferredNode: 'Նախընտրելի հանգույց',
      noPreference: 'Նախապատվություն չկա (ավտոմատ տեղաբաշխում)',
      preferNodes: 'Նախընտրելի հանգույցի թեգեր',
      requireNodes: 'Պարտադիր հանգույցի թեգեր',
      noPlacementTags: 'Ոչ մի',
      placementTag: 'Թեգ',
      placementValue: 'Արժեք',
      placementAddTag: 'Ավելացնել թեգ',
      proximityHa: 'TVirt Proximity-ի HA',
      proximityHaRestarts: 'HA վերագործարկումներ',
      proximityHaGaveUp: 'crash loop — HA-ն հանձնվել է',
      failoverProtection: 'Պաշտպանություն դեգրադացիայի ժամանակ',
      protectionProtected: 'Պաշտպանված',
      protectionExpendable: 'Զոհաբերելի դեգրադացիայի ժամանակ',
      protectionInherit: 'Ժառանգում է',
      lastStop: 'Վերջին կանգը',
      yes: 'Այո',
      no: 'Ոչ',
      tabOverview: 'Ընդհանուր պատկեր',
      tabSnapshots: 'Սնապշոթներ',
      tabBackups: 'Պատճեններ',
      hardware: 'Սարքաշար',
      name: 'Անուն',
      hwSystem: 'Համակարգ',
      hwCpu: 'CPU',
      hwMemory: 'Հիշողություն',
      hwBoot: 'Գործարկում',
      hwIdentity: 'Ինքնություն',
      hwCluster: 'Կլաստեր և agent',
      cpuTopology: 'CPU տոպոլոգիա',
      cpuModel: 'CPU մոդել',
      cpuLimit: 'CPU սահման',
      cpuWeight: 'CPU կշիռ',
      cpuNested: "Ներդրված վիրտուալացում",
      cpuNestedHint: "Բացում է vmx/svm-ը հյուրի համար (միայն host CPU մոդելով)։ Աշխատող VM-ի դեպքում փոփոխությունն ուժի մեջ է մտնում հաջորդ power cycle-ից (PendingRestart)․ տեղաբաշխումը թույլատրում է միայն nested-ը միացրած հանգույցներ։",
      unlimited: 'Անսահմանափակ',
      memory: 'Հիշողություն',
      balloon: 'Բալուն',
      hugePages: 'Հսկա էջեր',
      hugePagesTradeoff: 'Ավելի քիչ հասցեների թարգմանության աշխատանք և հիշողություն, որը երբեք սկավառակի վրա չի հայտնվում. փոխարենը պահուստը մնում է արգելափակված հանգույցի վրա, քանի դեռ VM-ը միացված է, հիշողությունն այլևս չի դեդուպլիկացվում, և գործարկումը ձախողվում է, եթե հանգույցը բավարար ազատ էջեր չունի։',
      disks: 'Սկավառակներ',
      cdroms: 'CD/DVD կրիչներ',
      nics: 'Ցանցային ինտերֆեյսներ',
      slot: 'Սլոթ',
      disk: 'Սկավառակ',
      encrypted: 'Գաղտնագրված',
      image: 'Պատկեր',
      emptyDrive: 'Դատարկ կրիչ',
      emptyOption: '(դատարկ)',
      network: 'Ցանց',
      mac: 'MAC',
      connected: 'Միացված',
      unplugged: 'Անջատված',
      noDevices: 'Ոչ մի',
      screenshot: 'Էկրանի պատկեր',
      capturedAt: 'Ֆիքսվել է',
      noCapture: 'Ֆիքսում չկա',
      snapshotName: 'Անուն',
      snapshotCreated: 'Ստեղծված',
      snapshotMemory: 'Հիշողությունը ներառված',
      noSnapshots: 'Սնապշոթներ չկան',
      pendingRestart: 'Սպասող փոփոխություններ. կկիրառվեն հաջորդ սնուցման ցիկլում։',
      applied: 'կիրառված',
      appliedHint: 'VM-ն աշխատում է այս արժեքով — կարգավորվածը կկիրառվի հաջորդ սնուցման ցիկլում։',
      actionError: 'Գործողությունը չհաջողվեց',
      actionStillRunning: 'Գործողությունը դեռ ընթացքի մեջ է՝ արդյունքը դեռ հայտնի չէ',
      tabConsole: 'Կոնսոլ',
      consoleConnect: 'Միանալ',
      consoleDisconnect: 'Անջատվել',
      consoleConnecting: 'Միացում…',
      consoleReconnecting: 'Միացում…',
      consoleUnavailable: 'Կոնսոլը հասանելի է, երբ VM-ն աշխատում է կամ դադարեցված է։',
      consoleError: 'Կոնսոլին միանալը չհաջողվեց',
      consoleTaken: 'Կոնսոլի սեանսը վերցրել է {user}-ը',
      consoleReconnect: 'Վերամիանալ',
      consoleCtrlAltDel: 'Ctrl+Alt+Del',
      consoleHold: 'Պահեք սեղմած {key}',
      consoleFn: 'Fn…',
      consoleFullscreen: 'Բացել ամբողջ էկրանով նոր ներդիրում',
      consoleLoadFailed: 'VM-ը չի գտնվել, կամ թույլտվություններն անբավարար են',
      consoleClose: 'Փակել',
      tabStats: 'Վիճակագրություն',
      tabTasks: 'Առաջադրանքներ',
      tabLogs: 'Մատյան',
      statsCpu: 'CPU',
      statsMemory: 'Հիշողություն',
      statsDisk: 'Սկավառակի I/O',
      statsRange: 'Միջակայք',
      statsNoData: 'Ընտրված միջակայքում տվյալներ չկան — վիճակագրությունը նմուշառվում է աշխատող VM-ի վրա։',
      statsError: 'Չհաջողվեց բեռնել վիճակագրությունը',
      cpuUsage: 'Օգտագործում',
      cpuReady: 'Ready (%RDY)',
      memUsed: 'Օգտագործված',
      memGuestAvailable: 'Հասանելի (հյուր)',
      schema: 'Սխեմա',
      consoleProtocol: 'Կոնսոլ',
      agentEnabled: 'Guest agent',
      metadataStorage: 'Մետատվյալների պահոց',
      startupOnBoot: 'Գործարկում հանգույցի բեռնման ժամանակ',
      startupOrder: 'Գործարկման կարգ',
      startupDelay: 'Գործարկման ուշացում',
      seconds: 'վ',
      enabled: 'Ակտիվացված',
      disabled: 'Ապաակտիվացված'
    },
    actionsAvailable: 'Հասանելի գործողություններ',
    actions: {
      start: 'Գործարկել',
      stop: 'Կանգնեցնել',
      pause: 'Դադարեցնել',
      resume: 'Վերսկսել',
      reset: 'Վերակայել',
      migrate: 'Միգրացնել',
      clone: 'Կլոնավորել',
      moveStorage: 'Տեղափոխել պահոց…',
      moveScope: 'Տեղափոխել սկոուպ…',
      openConsole: 'Բացել կոնսոլը',
      forceStop: 'Հարկադիր անջատում',
      markTemplate: 'Նշել որպես ձևանմուշ',
      unmarkTemplate: 'Վերադարձնել VM-ի',
      error: 'Չհաջողվեց կատարել գործողությունը'
    },
    cordon: {
      confirmTitle: 'Հանգույցը սպասարկման մեջ է',
      confirmHint:
        'Կորդոնը հնարավոր չէ իջեցնել, քանի դեռ կլաստերի store-ը անհասանելի է։ Հաստատելով դուք հայտարարում եք, որ գիտեք դա. ՎՄ-ն այնտեղ միևնույն է միանում է, և համաձայնությունը գրանցվում է առաջադրանքի վրա։',
      confirm: 'Միացնել այնուամենայնիվ'
    },
    markTemplate: {
      confirmTitle: 'Նշե՞լ {name}-ը որպես ձևանմուշ',
      confirmBody: 'Կոնֆիգուրացիան սառչում է, և VM-ն այլևս չի կարող միանալ — միայն կլոնավորվել կամ նորից VM դառնալ։ Անունը, նշումները և թեգերը մնում են խմբագրելի։',
      confirm: 'Նշել որպես ձևանմուշ',
      moved: '{name}-ն այժմ ձևանմուշ է — տեղափոխվել է Ձևանմուշներ ներդիր։'
    },
    unmarkTemplate: {
      confirmTitle: 'Վերադարձնե՞լ {name}-ը VM-ի',
      confirmBody: 'Ձևանմուշը նորից սովորական VM է դառնում. խմբագրելի և գործարկելի (հաջորդ գործարկումը տեղաբաշխում է այն հանգույցի վրա)։',
      confirm: 'Վերադարձնել VM-ի',
      moved: '{name}-ը նորից վիրտուալ մեքենա է — տեղափոխվել է Վիրտուալ մեքենաներ ներդիր։'
    },

    // Ռաունդ #123. հանգույցի հղում ԹԵԳՈՎ (ընտրիչ #106) գործարկման և
    // միգրացիայի երկխոսություններում — լուծված բազմության նախադիտումով:
    nodeByTag: {
      label: 'Ըստ հանգույցի թեգի',
      hint: 'թեգ=արժեք, ստորակետով բաժանված (AND-ով). որոշիչն ընտրում է համապատասխանող հանգույցների միջից',
      invalid: 'Անվավեր ձևաչափ — օգտագործեք թեգ=արժեք, ստորակետով բաժանված',
      resolved: 'Համապատասխանող անդամներ՝ {nodes}'
    },
    migrate: {
      title: 'Կենդանի միգրացիա',
      submit: 'Միգրացնել',
      target: 'Նշանակետ հանգույց',
      auto: 'Ավտոմատ (Proximity)',
      hint: 'VM-ը տեղափոխվում է առանց սնուցման ցիկլի։ Ամեն պահոց, որին այն դիպչում է, պետք է լինի համօգտագործվող. դադարեցված VM-ը միգրացվում է դադարեցված։',
      error: 'Միգրացիան մերժվեց'
    },
    moveStorage: {
      title: 'Տեղափոխել պահոց',
      submit: 'Տեղափոխել',
      target: 'Նշանակետ պահոց',
      noTargets: 'Ոչ մի պահոց սկավառակներ չի ընդունում',
      hint: 'Անջատված VM-ի բոլոր սկավառակները ճամփորդում են ընտրված պահոց, մեկ առ մեկ, պահելով իրենց id-ն — արդեն նշանակետում գտնվողները բաց են թողնվում։ Ընթացքն ապրում է առաջադրանքների էջում։',
      error: 'Տեղափոխումը մերժվեց'
    },
    moveScope: {
      title: 'Տեղափոխել սկոուպ',
      submit: 'Տեղափոխել',
      target: 'Նշանակետ սկոուպ',
      hint: 'VM-ն անմիջապես փոխում է սկոուպը — id-ն ու սկավառակները մնում են, սեփական սկավառակները հետևում են նրան, և այն կարող է մնալ միացված։ Այսօր այն ապրում է {scope}-ում։ Ով է տեսնում այն, փոխվում է սկոուպի հետ։',
      error: 'Սկոուպի տեղափոխումը մերժվեց'
    },
    start: {
      title: 'Գործարկել VM-ը',
      submit: 'Գործարկել',
      target: 'Նշանակետ հանգույց',
      auto: 'Ավտոմատ (խորհուրդ է տրվում)',
      recommended: 'խորհուրդ է տրվում',
      hint: 'Ընտրեք նշանակետ հանգույց կամ թողեք, որ Proximity-ն որոշի վավեր թեկնածուների միջից։ Այն հանգույցները, որոնք չեն կարող հյուրընկալել այն, անջատված են՝ պատճառի հետ միասին։',
      error: 'Չհաջողվեց գործարկել VM-ը'
    },
    console: {
      media: 'CD/DVD կրիչներ',
      mediaGuestToolsHint: 'Պարունակում է TVirt Guest Tools — այստեղից կարող եք հանել դրանք կամ հեռացնել կրիչը',
      slotOpsDeferred: 'Այս պրոֆիլի վրա կրիչների ավելացումն ու հեռացումը կիրառվում են հաջորդ սնուցման ցիկլում (կրիչի պարունակության փոփոխություններն ակնթարթային են)։',
      mountGuestTools: 'Միակցել TVirt Guest Tools',
      ejectGuestTools: 'Հանել TVirt Guest Tools',
      bootOrder: 'Բեռնման կարգ',
      bootOrderHint: 'Նոր կարգը պահպանվում է անմիջապես և կիրառվում հաջորդ սնուցման ցիկլում — կոնսոլի սեանսը մնում է միացված։'
    },
    snapshots: {
      create: 'Ստեղծել սնապշոթ',
      createTitle: 'Ստեղծել սնապշոթ',
      createSubmit: 'Ստեղծել',
      name: 'Անուն',
      nameHint: 'Տառեր, թվանշաններ, կետ, գծիկ, ընդգծում։',
      consistencyHint: 'Համաձայնեցվածությունն ավտոմատ է. guest agent-ը սառեցնում է ֆայլային համակարգերը, երբ պատասխանում է. հակառակ դեպքում VM-ը սնապշոթի պահին մի պահ դադարեցվում է։',
      memory: 'Ներառել հիշողությունը',
      memoryHint: 'Ֆիքսում է կենդանի RAM-ը. վերականգնումը վերսկսում է VM-ն աշխատող վիճակում։ Պահանջում է, որ բոլոր սկավառակները qcow2 լինեն։',
      currentChip: 'Դուք այստեղ եք',
      revert: 'Վերականգնել',
      revertTitle: 'Վերականգնե՞լ {name}-ը',
      revertBody: 'Սկավառակները վերադառնում են սնապշոթի վիճակին. այն ամենը, ինչ եղել է դրանից հետո, կորչում է։ Միայն-սկավառակների սնապշոթը պահանջում է կանգնեցված VM։',
      delete: 'Ջնջել',
      deleteTitle: 'Ջնջե՞լ {name} սնապշոթը',
      deleteBody: 'Վերականգնման կետն անհետանում է. սկավառակների պարունակությունը մնում է անձեռնմխելի։',
      deleteMergeHint: 'Նրա դելտան միաձուլվում է {children}-ի մեջ. յուրաքանչյուր հետագա վերականգնման կետ մնում է վավեր։',
      deleteDuplication: 'Ընդունում եմ կրկնօրինակումը',
      deleteDuplicationHint: 'Դելտան պատճենվում է {count} ընթերցողներից յուրաքանչյուրի մեջ (զավակ snapshot-ները և, եթե սա ընթացիկն է, ակտիվ գլուխը). զբաղեցրած տարածքը կարող է աճել՝ նվազելու փոխարեն։',
      error: 'Սնապշոթի գործողությունը մերժվեց'
    },
    clone: {
      title: 'Կլոնավորել VM-ը',
      submit: 'Կլոնավորել',
      name: 'Պատճենի անուն',
      storage: 'Սկավառակների նշանակետ պահոց',
      sameStorage: 'Նույնը, ինչ աղբյուրինը',
      full: 'Լրիվ պատճեն',
      fullHint: 'Պատճենում է ամեն բայթ և կտրում կապը աղբյուր սկավառակների հետ։ Լռելյայնը կապված կլոնն է. ակնթարթային, բայց շղթայված աղբյուրին (միայն qcow2)։',
      hint: 'Կլոնը պահում է աղբյուրի կոնֆիգուրացիան և որոնվածքը. MAC հասցեները և TPM ինքնությունը նոր են։',
      markAs: 'Կլոնի տեսակ',
      markAsInheritVm: 'Ինչպես աղբյուրը (VM)',
      markAsInheritTemplate: 'Ինչպես աղբյուրը (ձևանմուշ)',
      markAsVm: 'Վիրտուալ մեքենա',
      markAsTemplate: 'Ձևանմուշ',
      markAsHintVm: 'Ընտրեք Ձևանմուշ՝ պատճենը մեկ քայլով ձևանմուշ դարձնելու համար։',
      markAsHintTemplate: 'Ընտրեք Վիրտուալ մեքենա՝ այս ձևանմուշից մեկ քայլով տեղակայելու համար։',
      error: 'Կլոնավորումը մերժվեց'
    },
    bulk: {
      selected: 'ընտրված',
      deleteTitle: {
        one: 'Ջնջե՞լ ընտրված {count} VM-ը',
        other: 'Ջնջե՞լ ընտրված {count} VM-ները'
      },
      deleteBody: 'Ամեն VM անցնում է նույն պահակների միջով, ինչ մեկական ջնջումը. մերժումները հայտնվում են ըստ տարրի։',
      done: 'ընդունված',
      refused: 'մերժված'
    },
    delete: {
      button: 'Ջնջել',
      confirmTitle: 'Ջնջե՞լ {name}-ը',
      confirmBody: 'Վիրտուալ մեքենան և նրա սեփականություն հանդիսացող սկավառակները կջնջվեն։ Գործողությունն անշրջելի է։',
      keepDisks: 'Պահել սկավառակները',
      keepDisksHint: 'VM-ի հետ ստեղծված սկավառակները մնում են իրենց պահոցում որպես ինքնուրույն սկավառակներ։',
      confirm: 'Ջնջել',
      cancel: 'Չեղարկել',
      error: 'Ջնջումը չհաջողվեց',
      blockedPhase: 'Նախ կանգնեցրեք VM-ը',
      blockedProtected: 'VM-ը պաշտպանված է — նախ հանեք պաշտպանությունը',
      blockedDeleting: 'Ջնջումն արդեն ընթացքի մեջ է'
    },
    logs: {
      title: 'Մատյան',
      subtitle: 'Այս VM-ին դիպչող առաջադրանքների կառուցվածքային մատյանի ֆրեյմերը',
      when: 'Երբ',
      task: 'Առաջադրանք',
      level: 'Մակարդակ',
      message: 'Հաղորդագրություն',
      empty: 'Դեռ մատյան չկա',
      loadError: 'Չհաջողվեց բեռնել մատյանը — TVirt բեքենդը հասանելի՞ է'
    },
    stop: {
      title: 'Կանգնեցնել վիրտուալ մեքենան',
      modeGraceful: 'Սահուն անջատում',
      modeGracefulHint: 'Հյուր օպերացիոն համակարգին խնդրում են բնական ձևով անջատվել (ACPI). եթե այն անտեսում է խնդրանքը, ժամանակահատվածից հետո գործում է հարկադիր անջատումը։',
      modeForced: 'Հարկադիր անջատում',
      modeForcedHint: 'Անմիջապես կտրում է հոսանքը, ինչպես խրոցակը հանելը։',
      timeout: 'Պահեստային ժամանակահատված (վայրկյան)',
      timeoutHint: 'Հյուրին տրվող սպասումը՝ նախքան անջատումը հարկադրելը'
    },

    // Ստեղծման split կոճակի մենյուն (Luca 2026-07-23). «Զրոյից»-ը բացում է
    // վարպետը, մյուս երկու տարրերը ճանապարհային քարտեզի ստաբներ են:
    createFromScratch: 'Զրոյից',
    createFromTemplate: 'Ձևանմուշից',
    createQuickDeploy: 'TVirt QuickDeploy',

    quickDeploy: {
      title: 'TVirt QuickDeploy',
      submit: 'Կատարել deploy',
      error: 'Deploy-ը ձախողվեց',
      compatNote: 'QuickDeploy-ը պահանջում է QuickDeploy-ի հետ համատեղելի ձևանմուշ. հարթակը առաջին գործարկման ժամանակ հարմարեցնում է հյուրին (ցանց, տիրույթ, ակտիվացում)։',
      template: 'Ձևանմուշ',
      noTemplates: 'Ոչ մի ձևանմուշ դեռ չի հայտարարում QuickDeploy-ի համատեղելիություն — հայտարարեք այն Ձևանմուշներ ներդիրից (Linux՝ cloud-init-ով, Windows՝ cloudbase-init-ով sysprep-ից հետո)',
      osLinux: 'Linux (cloud-init)',
      osWindows: 'Windows (cloudbase-init)',
      hostname: 'Հոսթի անուն',
      hostnameHint: 'Հոսթի անուն կամ FQDN. դատարկ = VM-ի անունը (Windows՝ առավելագույնը 15 նիշ)',
      ip: 'IP հասցե',
      ipHint: 'Հոսթ և նախածանց, օր.՝ 192.168.122.101/24. դատարկ = DHCP',
      gateway: 'Gateway',
      dns: 'DNS սերվերներ',
      dnsHint: 'Մինչև երեքը, ստորակետով բաժանված',
      count: 'Օրինակներ',
      countHint: 'Մեկից ավելի. անվանվում են <անուն>-1…-N, միայն DHCP',
      user: 'Օգտատեր',
      userHint: 'Դատարկ = պատկերի լռելյայն օգտատերը (Linux) կամ Administrator (Windows)',
      password: 'Գաղտնաբառ',
      passwordHint: 'Գրվում է գեներացված user-data-ի մեջ, որը հարթակն այնուհետև հայտարարում է գաղտնի. ոչ ոք այն նորից չի կարդում',
      sshKeys: 'SSH հանրային բանալիներ',
      sshKeysHint: 'Մեկը յուրաքանչյուր տողում (ssh-ed25519 AAAA… մեկնաբանություն)',
      productKey: 'Windows-ի product key',
      kmsServer: 'KMS սերվեր',
      kmsHint: 'Հոսթ կամ հոսթ:պորտ — պահանջում է product key (KMS հաճախորդի բանալի)',
      adDomain: 'Միանալ Active Directory տիրույթին',
      adDomainHint: 'Դատարկ = առանց տիրույթին միանալու',
      adUser: 'Միանալու հաշիվ',
      adPassword: 'Միանալու հաշվի գաղտնաբառ',
      adOu: 'Նպատակային OU (ըստ ցանկության)',
      advanced: 'Ընդլայնված. հում փաստաթղթեր',
      userData: 'user-data (հում)',
      userDataHint: 'Փոխարինում է գեներացված user-data-ն. վերևի օգտատերը, գաղտնաբառը, բանալիները և Windows-ի դաշտերը պետք է դատարկ մնան',
      networkConfig: 'network-config (հում)',
      networkConfigHint: 'Փոխարինում է գեներացված ցանցը. վերևի IP-ն, gateway-ը և DNS-ը պետք է դատարկ մնան',
      secret: 'Հում user-data-ն համարել գաղտնի',
      secretHint: 'Գաղտնի նշվելով՝ API-ն այն այլևս ոչ ոքի չի վերադարձնում, իսկ Checkpoint-ում այն ճանապարհորդում է masterpass-ով կնքված',
      startNow: 'Գործարկել անմիջապես',
      startNowHint: 'Յուրաքանչյուր օրինակ գործարկվում է սահմանվելուն պես. seed-ը ստեղծվում է այդ գործարկման ժամանակ'
    },

    create: {
      nicAttachmentNetwork: 'Տրամաբանական ցանց (fabric)',
      nicNetwork: 'Տրամաբանական ցանց',
      nicNetworkHint: 'ԽՈՐՀՈՒՐԴ ՏՐՎՈՂ ճանապարհը (F3). vNIC-ը իրականանում է սպասարկող հանգույցի ԱԾԱՆՑՅԱԼ bridge-ի վրա — bridge-ը ծնվում է fabric-ի բացահայտ apply-ի ժամանակ, և գործարկումը հանգույցի վրա, որը դեռ չի կրում այն, մերժում է խոսելով։ Երբ նավատորմի վերջին հղումը հեռանում է, bridge-ը դուրս է ընկնում հաջորդ apply-ի ժամանակ։',
      button: 'Ստեղծել VM',
      title: 'Ստեղծել վիրտուալ մեքենա',
      dialogTitle: 'Ստեղծել վիրտուալ մեքենա',
      stepGeneral: 'Ընդհանուր',
      stepGeneralHint: 'Անուն և պրոֆիլ',
      stepCompute: 'CPU և RAM',
      stepComputeHint: 'Տոպոլոգիա և չափեր',
      stepDisks: 'Սկավառակներ',
      stepDisksHint: 'Ստեղծել կամ կցել',
      stepCdroms: 'CD/DVD',
      stepCdromsHint: 'Կրիչներ և կրիչային պարունակություն',
      stepNetwork: 'Ցանց',
      stepNetworkHint: 'NIC-եր. տրանկ կամ կամուրջ',
      stepSummary: 'Ամփոփում',
      stepSummaryHint: 'Ստուգել և ստեղծել',
      name: 'Անուն',
      nameHint: 'Փոքրատառեր, թվանշաններ և գծիկներ (DNS-1123)',
      nextButton: 'Առաջ',
      prevButton: 'Ետ',
      submitButton: 'Ստեղծել',
      creating: 'Ստեղծում…',
      sockets: 'Սոկետներ',
      cores: 'Միջուկ ամեն սոկետի',
      threads: 'Հոսք ամեն միջուկի',
      totalVcpus: 'Ընդամենը vCPU',
      memoryGib: 'Հիշողություն (GiB)',
      cpuModelHint: "'host'-ը բացում է հոսթի CPU-ն",
      cpuLimitHint: 'Առաստաղ հոսթի միջուկներով — դատարկ = անսահմանափակ',
      cpuNestedHint: "Բացում է vmx/svm-ը հյուրի համար, որ նա կարողանա աշխատեցնել իր hypervisor-ը — պահանջում է host CPU մոդել և nested-ը միացրած հանգույց",
      newDisk: 'Նոր սկավառակ',
      attachDisk: 'Կցել գոյություն ունեցող սկավառակ',
      diskStorage: 'Պահոց',
      diskSize: 'Չափ (GiB)',
      diskSelect: 'Սկավառակ',
      addDisk: 'Ավելացնել սկավառակ',
      addCdrom: 'Ավելացնել CD/DVD կրիչ',
      addNic: 'Ավելացնել ցանցային ինտերֆեյս',
      remove: 'Հեռացնել',
      slotLimit: 'Սլոթների սահմանը լրացել է',
      cdromImage: 'Պատկեր (բացակայության դեպքում՝ դատարկ կրիչ)',
      nicAttachment: 'Միացում',
      nicAttachmentTrunk: 'Օվերլեյ տրանկ',
      nicAttachmentBridge: 'Հոսթի կամուրջ',
      nicUntagged: 'Untagged օվերլեյ',
      nicUntaggedNone: 'Ոչ մի (միայն tagged)',
      nicTrunkHint: 'Առնվազն մեկ կողմ. untagged օվերլեյ և/կամ tagged VLAN քարտեզագրումներ — VM-ը կարող է աշխատել միայն այն հոսթերի վրա, որոնք հայտարարված են ամեն հղված օվերլեյի կողմից',
      nicTaggedVlan: 'VLAN ID',
      nicTaggedOverlay: 'Օվերլեյ ցանց',
      addTagged: 'Ավելացնել tagged VLAN',
      nicBridge: 'Հոսթի կամրջի անուն',
      nicBridgeHint: 'NM կամուրջ ըստ անվան — VM-ը կարող է աշխատել միայն այն սերվերների վրա, որոնց հոսթի ցանցը հայտարարում է այս կամուրջը',
      nicMac: 'MAC (ավտոմատ, եթե դատարկ է)',
      noDisksHint: 'Սկավառակ չկա. VM-ը կունենա միայն ձեր ավելացրած CD/DVD կրիչները։',
      noCdromsHint: 'CD/DVD կրիչ չկա. ավելացրեք մեկը՝ ISO պատկերից գործարկելու համար։',
      mountGuestTools: 'Միակցել TVirt Guest Tools առաջին գործարկման ժամանակ',
      mountGuestToolsHint: 'Դնում է virtio դրայվերներով և guest agent-ով ISO-ն դատարկ CD կրիչում (ավելացվում է, եթե պետք է) — Windows-ի տեղադրիչը դրա կարիքն ունի սկավառակները տեսնելու համար։',
      noNicsHint: 'Ցանցային ինտերֆեյս չկա. VM-ը կգործարկվի առանց կապի։',
      taggedMappings: 'Tagged VLAN քարտեզագրումներ',
      summaryDevices: 'Սարքեր',
      bootOrderTitle: 'Բեռնման կարգ',
      bootOrderHint: 'Քաշեք՝ վերադասավորելու համար — հաղթում է առաջին բեռնվող սարքը. NIC-երը գործարկում են PXE',
      bootOrderUp: 'Տեղափոխել վերև',
      bootOrderDown: 'Տեղափոխել ներքև',
      createError: 'Ստեղծումը չհաջողվեց'
    },
    edit: {
      button: 'Խմբագրել',
      title: 'Խմբագրել վիրտուալ մեքենան',
      cancel: 'Չեղարկել',
      save: 'Պահպանել',
      error: 'Փոփոխությունը չհաջողվեց',
      modelStoppedOnly: 'Խմբագրելի է միայն անջատված VM-ի վրա',
      firmwareStoppedOnly: 'Որոնվածքը խմբագրելի է միայն անջատված VM-ի վրա — հաջորդ գործարկման ժամանակ մեքենան մեկնարկում է նոր որոնվածքով, և UEFI փոփոխականները մնում են',
      hugePagesStoppedOnly: 'Խմբագրելի է միայն անջատված VM-ի վրա — հաջորդ գործարկման ժամանակ հիշողությունը ծնվում է նոր backing-ով',
      runningHint: 'Փոփոխությունները կիրառվում են հաջորդ սնուցման ցիկլում',
      sectionCpu: 'CPU',
      sectionMemory: 'Հիշողություն',
      sectionPolicy: 'Չափանիշներ'
    },
    devices: {
      networkChip: 'fabric ցանց',
      title: 'Սարքեր',
      usb: 'USB',
      gpu: 'GPU',
      addUsb: 'Ավելացնել USB սարք',
      addUsbTitle: 'Պահանջել USB սարքերի դաս',
      usbClassHint:
        'VM-ը պահանջում է USB սարքերի ԴԱՍ (usb-device թեգի արժեք), երբեք կոնկրետ սարք. գործարկման պահին հանգույցի վրա ընտրվում և ամրագրվում է կոնկրետ ազատ սարքը։ Թեգավորեք գրանցված սարքերը Կլաստեր › USB և PCIe ռեսուրսներ բաժնում։',
      usbTag: 'Թեգ (usb-device)',
      usbValue: 'Դասի արժեք',
      noUsbTags: 'usb-device թեգ չկա — ստեղծեք մեկը և թեգավորեք գրանցված սարքերը Կլաստեր › USB և PCIe ռեսուրսներ բաժնում։',
      noUsbValues: 'Այս թեգը դեռ հայտարարված արժեքներ չունի։',
      usbEmpty: 'USB պահանջ չկա — ավելացրեք դաս՝ գործարկման պահին սարք փոխանցելու համար։',
      usbClassChip: 'դաս',
      usbPortChip: 'պորտ',
      usbUnclaimed: 'Ամրագրված սարք չկա — լուծվում է VM-ի գործարկման պահին։',
      addGpu: 'Ավելացնել GPU',
      addGpuTitle: 'Պահանջել GPU դաս',
      gpuClassHint:
        'VM-ը պահանջում է GPU ԴԱՍ (gpu-device թեգի արժեք), երբեք կոնկրետ քարտ. գործարկման պահին հանգույցի վրա ընտրվում և ամրագրվում է կոնկրետ ազատ քարտը, և ՄԻԱՍԻՆ փոխանցվում է նրա ամբողջ IOMMU խումբը։ Թեգավորեք գրանցված GPU-ները Կլաստեր › USB և PCIe ռեսուրսներ բաժնում։',
      gpuTag: 'Թեգ (gpu-device)',
      gpuValue: 'Դասի արժեք',
      noGpuTags: 'gpu-device թեգ չկա — ստեղծեք մեկը և թեգավորեք գրանցված GPU-ները Կլաստեր › USB և PCIe ռեսուրսներ բաժնում։',
      noGpuValues: 'Այս թեգը դեռ հայտարարված արժեքներ չունի։',
      gpuEmpty: 'GPU պահանջ չկա — ավելացրեք դաս՝ գործարկման պահին քարտ փոխանցելու համար։',
      gpuClassChip: 'դաս',
      gpuGroupChip: 'IOMMU խումբ ×',
      gpuUnclaimed: 'Ամրագրված քարտ չկա — լուծվում է VM-ի գործարկման պահին։',
      gpuPowerCycle: 'GPU hotplug չկա — փոփոխություններն ուժի մեջ են հաջորդ սնուցման ցիկլից (PendingRestart)',
      actions: 'Գործողություններ',
      attachDisk: 'Ավելացնել սկավառակ',
      attachDiskTitle: 'Ավելացնել սկավառակ',
      attach: 'Կցել',
      noFreeDisks: 'Չօգտագործված սկավառակ չկա — ստեղծեք մեկը Վիրտուալ մեքենաներ › Չօգտագործված սկավառակներ բաժնում։',
      addCdrom: 'Ավելացնել կրիչ',
      addCdromTitle: 'Ավելացնել CD/DVD կրիչ',
      editCdromTitle: 'Փոխել CD/DVD պատկերը',
      changeMedia: 'Փոխել CD/DVD պատկերը',
      ejectMedium: 'Հանել',
      mountGuestTools: 'Միակցել TVirt Guest Tools',
      guestToolsMounted: 'TVirt Guest Tools-ը միակցված է',
      guestToolsClickMount: 'Դնում է TVirt Guest Tools ISO-ն առաջին դատարկ CD/DVD կրիչում',
      guestToolsClickUnmount: 'Սեղմեք՝ հանելու համար — կրիչը մնում է, դատարկ',
      guestToolsNoSlot: 'Դատարկ CD/DVD կրիչ չկա — ավելացրեք կրիչ (կամ հանեք պարունակությունը)՝ TVirt Guest Tools-ը միակցելու համար',
      guestToolsSkew: 'Միացված է v{pinned}. {node} հանգույցն այժմ մատուցում է v{current}. հանեք և նորից միացրեք թարմացնելու համար',
      ejectGuestTools: 'Հանել TVirt Guest Tools (կրիչը մնում է, դատարկ)',
      guestToolsEjectConfirmTitle: 'Հանե՞լ TVirt Guest Tools-ը',
      guestToolsEjectConfirmBody: 'Կրիչային պարունակությունը հանվում է միացված VM-ից — CD/DVD կրիչը մնում է, դատարկ։',
      applyLive: 'Կիրառել անմիջապես (VM-ը միացված է)',
      addNic: 'Ավելացնել ինտերֆեյս',
      addNicTitle: 'Ավելացնել ցանցային ինտերֆեյս',
      editNicTitle: 'Խմբագրել ցանցային ինտերֆեյսը',
      bridgeChip: 'կամուրջ',
      cable: 'Վիրտուալ մալուխ',
      plug: 'Միացնել վիրտուալ մալուխը',
      unplug: 'Անջատել վիրտուալ մալուխը',
      remove: 'Հեռացնել',
      removeTitle: 'Հեռացնե՞լ {device}-ը',
      removeBody: 'Միացված VM-ի վրա փոփոխությունը կիրառվում է հաջորդ սնուցման ցիկլում։ Սկավառակները և պատկերները ապակցվում են, երբեք չեն ջնջվում։'
    }
  }
}
